import GetSchedulerByReferentsRequestModel from '../../../generated/types/model/request/GetSchedulerByReferentsRequestModel';

export default class GetSchedulerByReferentsRequestViewModel extends GetSchedulerByReferentsRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
